import { UniDriver } from '@wix/wix-ui-test-utils/dist/types/unidriver';
import { iconButtonDriverFactory as publicDriverFactory } from './IconButton.uni.driver';

export const iconButtonPrivateDriverFactory = (base: UniDriver) => {
  return {
    ...publicDriverFactory(base),
    getIconSize: async () =>
      await base.$('[data-hook="iconbutton-icon"]').attr('height'),
  };
};
